var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}

site.frontpage = {
	init: function () {
		var $body = $('body');
		if (!$body.hasClass('frontpage')) return false;

		site.owl.init('#owl-hero', {
			loop:false,
			dots:true,
			items:1
		});
		site.owl.init('#newsItems', {
			loop:false,
			dots:false,
			nav:true,
			navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
			items:4,
			responsive: {
				0: {
					items:1
				},
				768: {
					items:2
				},
				992: {
					items:3
				},
				1200: {
					items:4
				}
			}
		});
		site.owl.init('#tilvitnun >ul', {
			loop:false,
			dots:false,
			nav:true,
			navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
			items:4,
			responsive: {
				0: {
					items:1
				},
				768: {
					items:2
				},
				992: {
					items:3
				},
				1200: {
					items:4
				}
			}
		});
	}
}

site.page = {
	album: function() {
		var $images = $('#page .pageImages');
		$images.find('.image img').responsiveImg();
		$firstImage = $images.find('.image:first');

		$images.find('img').on("load", function() {
			site.page.resizeFirst($firstImage);
		});
		$(window).on('resize', function(){
			site.page.resizeFirst($firstImage);
		});
	},
	resizeFirst: function(first) {
		$first = first;
		var $img = $first.next('.image');
		var nextHeight = $img[0].getBoundingClientRect().height;
		$first.css('height',nextHeight);
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.donate = {
	init: function () {
		$('.donate-box').find('button').click(function () {
			$.post($(this).parent().attr('action'), {amount: $(this).parent().find('.text').val()}, function (results) {
				if (!results.error) {
					var url = results.url;
					window.location.replace(url);
				}
				else {
					alert(results.message);
				}
			}, 'json')
		})
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.nav.init();
	site.frontpage.init();

	if ($('body').hasClass('pageAlbum')) {
		site.page.album();
	}
	if ($('body').hasClass('english')) {
		$('#qn ul.lang li').removeClass('selected').first().addClass('selected');
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

site.inits.push('site.donate.init()');
